export { default as setGlobalTheme } from '../set-global-theme';
